module.exports = __webpack_public_path__ + "img/hongshu.6762434a.png";